import { Accordion } from '@cleartax/wg-library-accordian';
import { useState } from 'react';
import { ISection } from '../../../../../pages/services/[planSeoSlug]/p/components/page-sections/types';
import { usePlanCtx } from '../../../../../pages/services/[planSeoSlug]/p/planDetailsContext';
import { trackAction } from '../../../../utils';
import { navigationCtx } from '../context';
import { INavigatorVariant } from '../types';
import { getNameOfSection, scrollIntoView } from '../utils';

export const VerticalAccordian: React.FC<INavigatorVariant> = ({
  className = '',
  scrollOffset = 0,
}) => {
  const { sections, activeSection, setActiveSectionCB, setJustScrolledCB } =
    navigationCtx();

  const planContext = usePlanCtx();

  const [dropdownOpen, setDropdownOpen] = useState(false);

  const handleClick = (id: string, element: HTMLDivElement) => {
    setJustScrolledCB(true);
    setActiveSectionCB(id);
    scrollIntoView(element, scrollOffset);
    setDropdownOpen(false);
    trackAction('click', '', { label: `${id}_${planContext.seoSlug}` });
  };
  return (
    <nav className={className}>
      <Accordion
        onClick={() => setDropdownOpen((prev) => !prev)}
        isExpandedState={dropdownOpen}
        header={getNameOfSection(sections, activeSection)}
        accordianHeaderEleClasses={
          'wg-container text-s-14 h-10 text-brand-700 my-0 bg-brand-200 flex justify-start flex-shrink items-center'
        }
      >
        <ul className="bg-white wg-container bg-brand-100">
          {sections.map((section) => {
            const sectionProps: ISection = section.props;
            const { id, name } = sectionProps;
            const isActiveSection = id === activeSection;
            return (
              <li
                key={id}
                className={`text-s-14 py-2 cursor-pointer ${
                  isActiveSection
                    ? 'text-brand-700 underline font-bold'
                    : 'text-grey-700 font-medium'
                }`}
                onClick={() => {
                  handleClick(id, section.ref.current as HTMLDivElement);
                }}
              >
                {name}
              </li>
            );
          })}
        </ul>
      </Accordion>
    </nav>
  );
};
